export const handleUrlUpdate = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('id');
    url.searchParams.delete('esign-templateId');
    window.history.pushState({}, '', url.toString());
};
